import { render } from "./internationalRelations.vue?vue&type=template&id=17050024&scoped=true"
import script from "./internationalRelations.vue?vue&type=script&lang=js"
export * from "./internationalRelations.vue?vue&type=script&lang=js"

import "./internationalRelations.vue?vue&type=style&index=0&id=17050024&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17050024"]])

export default __exports__